var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$route.path !== '/' && _vm.$route.path !== '/forgotPassword')?_c('HeaderPage'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }